import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { HttpClient } from '@angular/common/http';
import { SchoolServices } from '../services';
import { HomePage } from '../../home/home';
import { OrdersCoServices } from '../../orders/services';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the DishListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-classrooms-students-list',
  templateUrl: 'classrooms-students-list.html',
})
export class ClassroomsStudentsListPage {

  classroom: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public http: HttpClient,
    public schoolServices: SchoolServices,
    public ordersCoServices: OrdersCoServices,
    public translate: TranslateService) {

    this.classroom = this.navParams.get('classroom');

  }


  onBack() {
    this.navCtrl.pop();
  }

  async openRestaurant(uid_restaurant) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-abriendo-restaurante-alumno')
    });
    loadingPopup.present();
    //
    this.schoolServices.enter_rest = true;

    //recuperar restaurant
    var restaurant = await this.globals.getRestaurantAsync(uid_restaurant);

    //abrir rest
    this.globals.restaurant_uid = uid_restaurant;
    this.globals.RESTAURANT_TAX = restaurant.tax_percentage;
    this.globals.user_name = restaurant.name;
    this.globals.user_email = restaurant.email;
    this.globals.user_rol = 'admin';
    this.globals.user_type = 'teacher';
    await this.globals.getRestaurant(uid_restaurant);
    await this.getWaiter();
    this.navCtrl.setRoot(HomePage);
    loadingPopup.dismiss();
  }

  async getWaiter() {
    var users = await this.ordersCoServices.getAccessCodes();

    for (let user of users) {
      for (let restaurant of this.globals.objectToArray(user.restaurants)) {
        if (restaurant.UID_RESTAURANT == this.globals.restaurant_uid) {
          if (restaurant.rol == 'admin') {
            this.globals.waiter = user.name;
            this.globals.waiter_uid = user.UID;
          }
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/pages/schools/classrooms-students-list/classrooms-students-list.ts